import React from 'react';
import styles from './styles.module.scss';

interface IProps {
    children: React.ReactNode;
}

const GuestLayout = ({children}:IProps) => {
    return (
        <div className={styles.layout}>
            <div>
                {children}
            </div>
        </div>
    );
};

export default GuestLayout;
